import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
  state: () => ({
    token: null,
    tokenType: null,
    expiresOn: null,
    scopes: null,
    name: null,
    userId: null,
    systemConfig: null,
    authenticated: false  
  }),
});
